import { Component } from '@angular/core'
import { Theme, ThemeService } from '../../services/theme.service'
import { Venue, VenueService } from '../../services/venue.service'
import { environment } from '../../../environments/environment'
import { TranslateService } from '@ngx-translate/core'

@Component({
	selector: 'app-start-page',
	templateUrl: './start-page.component.html',
	styleUrls: ['./start-page.component.scss'],
})
export class StartPageComponent {
	errorCode = false

	venue: Venue
	theme: Theme

	isLiveMenuPro = false

	constructor(
		private venueService: VenueService,
		private themeService: ThemeService,
		private _translateService: TranslateService
	) {
		this.theme = this.themeService.getTheme()

		this.venue = this.venueService.getVenue
		this.isLiveMenuPro = this.venueService.hasLiveMenuPro()
	}

	getLogo(): string {
		const logo = this.theme?.logo?.horizontal
		return logo ? environment.thumbsImage + logo : '../../../assets/images/tagme-logo.svg'
	}

	welcomeMessage(name): string {
		return name ? `${this._translateService.instant('startPage.venueGreetings', { name })}` : this._translateService.instant('startPage.welcome')
	}
}
